/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Modal, notification, Row } from "antd";
import React, { useEffect, useState } from "react";
import TextEditor from "../../../../../../components/TextEditor";
import { axios, getToken, URL_API, _ } from "../../../../../../utils";
import { Panel, PanelBody, PanelHeader } from "../../../../../util/panel";

function RP_Title({ history, form, ...props }) {
  const [loadValue, setLoadValue] = useState("");
  const [textEditorTitle, setTextEditorTitle] = useState("");

  const handleClickSubmit = () => {
    form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return notification.warning({
          message: "กรุณาตรวจสอบรายการ",
          description: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
      }

      console.log({ values });

      let formData = new FormData();
      formData.append(
        "data",
        JSON.stringify({
          ..._.omit(values),
          title: textEditorTitle,
        })
      );

      Modal.confirm({
        title: "ยืนยัน",
        content: "ต้องการบันทึกข้อมูลหรือไม่",
        okText: "บันทึก",
        cancelText: "ปิด",
        onOk() {
          return new Promise((resolve, reject) => {
            axios({
              method: "post",
              baseURL: URL_API,
              url: "/manage-website/ecosystem/reward-point/rp-title",
              headers: { Authorization: "Bearer " + getToken() },
              data: formData,
            })
              .then((res) => {
                console.log(res);
                resolve("success");
              })
              .catch((err) => {
                console.log(err);
                reject(
                  err && err.response
                    ? err.response.data.message
                      ? err.response.data.message
                      : err.response.data
                    : err.message
                );
              });
          })
            .then(() => {
              Modal.success({
                title: "สำเร็จ",
                content: "บันทึกเรียบร้อย",
                okText: "ปิด",
                onOk() {
                  history.go(0);
                },
              });
            })
            .catch((reason) => {
              Modal.error({
                title: "ผิดพลาด",
                content: reason,
                okText: "ปิด",
              });
            });
        },
      });
    });
  };

  const loadContent = () => {
    axios({
      method: "get",
      baseURL: URL_API,
      url: "/manage-website/ecosystem/reward-point/rp-title",
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then((res) => {
        console.log(res);
        var data = res.data?.data;
        setLoadValue(data);
        setTextEditorTitle(data.title);

        form.setFieldsValue({
          ...data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    loadContent();
  }, []);

  // const { getFieldDecorator } = form;

  return (
    <>
      <Panel>
        <PanelHeader>Title RP</PanelHeader>
        <PanelBody>
          <Form layout="vertical">
            <Row>
              <h5>title</h5>
              <TextEditor
                selector="textarea"
                plugins="textcolor "
                toolbar="forecolor"
                authToken={getToken()}
                value={textEditorTitle}
                onInit={(evt, event) => {}}
                onEditorChange={(e) => {
                  setTextEditorTitle(e);
                }}
                onUploadSuccess={(json) => {
                  console.log(json);
                }}
                postBody={{ container_name: "web-content" }}
                urlUpload={`${URL_API}/file/upload`}
              />
            </Row>
            <Row>
              <Button type="primary" onClick={() => handleClickSubmit()}>
                {loadValue != null ? "Update" : "Save"}
              </Button>
            </Row>
          </Form>
        </PanelBody>
      </Panel>
    </>
  );
}
export default Form.create("home-intro")(RP_Title);
